export default __webpack_public_path__ + "static/media/expo_logo_white.270a854b.png";